import {
  loadDevMessages,
  loadErrorMessages
} from '@apollo/client/dev';
import {
  CssBaseline,
  ThemeProvider
} from '@mui/material';

import { router } from 'activities';

import { RouterProvider } from 'react-router-dom';
import { theme } from './theme/index';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
